import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, NgZone, ChangeDetectorRef, AfterViewChecked, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from "@angular/router";
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { slideInAnimation } from '../animations/route-animation';
declare var $: any;
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { noWhitespaceInRequiredValidator, password_validation } from '../shared/constants';
import { noop } from 'rxjs';
import { ChangePasswordFormComponent } from '../masters/users/change-password-form/change-password-form.component';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
	animations: [slideInAnimation]
})
export class NavbarComponent implements OnInit, AfterViewChecked {
	homeUrl = this.apiService.getHomeURL();
	user: any = {
		first_name: localStorage.getItem("first_name"),
		last_name: localStorage.getItem("last_name"),
		email: localStorage.getItem("email")
	};
	userLoader = false;
	@ViewChild(ChangePasswordFormComponent) resetPasswordForm!: ChangePasswordFormComponent;

	constructor(private _snackBar: MatSnackBar, private changeRef: ChangeDetectorRef, private observer: BreakpointObserver, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) { }

	ngOnInit(): void {
		/* this.userLoader = true;
		this.apiService.getUserAccess().subscribe({
			next: (response: any) => {
				this.userLoader = false;
				this.user = response.data;
				this.apiService.setUserData(this.user);
			}, error: (error) => {
				this.userLoader = false;
				this.user = null;
				this.apiService.setUserData(this.user);
				this.toastr.error("Something went wrong", 'Error!', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		}); */
	}

	ngAfterViewChecked(): void {
		this.changeRef.detectChanges();
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}

	logoutUser() {
		this.apiService.navigateToLogin(false);
	}

	openResetPasswordModal() {
		this.resetPasswordForm.openResetPasswordModal();
		/* if (this.user && this.user.email) {
			this.resetPasswordForm.username = this.user.email;
			this.resetPasswordForm.openResetPasswordModal();
		} else {
			this.toastr.error("Something went wrong", 'Error!', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		} */
	}

	scrollToTop() {
		let selector = "#page-content-container-common";
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 70 + 'px'
			}, 'fast');
		} catch (error) { }
	}

	showScrollBtn = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(e: any) {
		try {
			if ($('#main-menu-header').offset().top) {
				this.showScrollBtn = true;
			} else {
				this.showScrollBtn = false;
			}
		} catch (error) { }
	}
}
